import {
  SystemOverviewRiskSummaryDocument,
  type SystemOverviewRiskTable,
  SystemOverviewRiskTableDocument,
} from "$/__generated__/graphql";
import { OverviewDataTables } from "components/tables";
import {
  RISK_SUMMARY_BASE_DEFS,
  RISK_SUMMARY_ROUNDING,
} from "constants/column-defs";
import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import {
  useDataTable,
  useDataTableSummaries,
  useSummariesFormatters,
} from "hooks/queries";
import { useAppliedColumns } from "hooks/useAppliedColumns";

export const SystemOverviewRiskSummaries = () => {
  const { hierarchyIdsOverview } = useGlobalFiltersContext();

  const {
    showFoot,
    systemMetric,
    selectionMetric,
    setSelectionMetric,
    setSystemMetric,
    setShowFoot,
    rows,
    loading,
    fetchMoreDataTable,
    isFetchingMore,
  } = useDataTable<SystemOverviewRiskTable>(
    "systemOverviewRiskTable",
    SystemOverviewRiskTableDocument,
    {
      variables: {
        hierarchyIds: hierarchyIdsOverview,
      },
    },
  );

  const appliedColumns = useAppliedColumns<SystemOverviewRiskTable>(
    "Risk",
    RISK_SUMMARY_BASE_DEFS,
  );

  const { columns } = useDataTableSummaries(
    appliedColumns,
    SystemOverviewRiskSummaryDocument,
    {
      variables: {
        hierarchyIds: hierarchyIdsOverview,
        selectionMetricType: selectionMetric,
        systemMetricType: systemMetric,
      },
    },
    useSummariesFormatters(
      selectionMetric,
      systemMetric,
      RISK_SUMMARY_ROUNDING,
    ),
  );

  return (
    <OverviewDataTables
      loading={loading}
      data={rows}
      columns={columns}
      selectionValue={selectionMetric}
      systemValue={systemMetric}
      showFoot={showFoot}
      onSelectionChange={setSelectionMetric}
      onSystemChange={setSystemMetric}
      setShowFoot={setShowFoot}
      onFetchMore={fetchMoreDataTable}
      isFetchingMore={isFetchingMore}
    />
  );
};

export default SystemOverviewRiskSummaries;
